<div id="comment-container">
    <div id="pp-container">
        <img [src]= "comment.profileUrl" alt="">
    </div>
    <div id="info-sub-container">
        <div id="name-date-container">
            <h3>{{comment.profileName}}</h3>
            <p>{{comment.date}}</p>
        </div>
        <div id="comcomment-container">
            <p>{{comment.comment}}</p>
        </div>
        <div id="like-reply-container">
            <div id="like-reply-sub-container">
                <span class="material-icons icon-color icon-size">thumb_up</span>
                <p>{{comment.likes | shortNumber}}</p>
                <p>REPLY</p>
            </div>
            <a href="">View {{comment.replies | shortNumber}} replies</a>
        </div> 
    </div>
</div>